import { NgModule } from '@angular/core';
import { Routes, RouterModule, ChildrenOutletContexts } from '@angular/router';
import { scheduled } from 'rxjs';
import { AppComponent } from './app.component';
import { AssesmentComponent } from './assesment/assesment.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DairyComponent } from './dairy/dairy.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { FeedtlsComponent } from './feedtls/feedtls.component';
import { GalleryComponent } from './gallery/gallery.component';
import { HolidaysComponent } from './holidays/holidays.component';
import { LayoutComponent } from './layout/layout.component';
import { LibraryComponent } from './library/library.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { PTMComponent } from './ptm/ptm.component';
import { ReportcardComponent } from './reportcard/reportcard.component';
import { TimetableComponent } from './timetable/timetable.component';

import { NotificationComponent } from './notification/notification.component';
import { GalimagesComponent } from './galimages/galimages.component';
import { ResultComponent } from './result/result.component';

const routes: Routes = [

  {path: '',  redirectTo: 'login', pathMatch: 'full' } ,
  { path: 'login', component: LoginComponent },
  {
  path: 'app', component: LayoutComponent, 
  children:[
      {path:'dash',component:DashboardComponent},
      {path:'feedtls',component:FeedtlsComponent},
      {path:'gallery',component:GalleryComponent},
      {path:'report',component:ReportcardComponent},
      {path:'calendar',component:CalendarComponent},
      {path:'holidays',component:HolidaysComponent},
      {path:'ptm',component:PTMComponent},
      {path:'assesment',component:AssesmentComponent},
      {path:'timetable',component:TimetableComponent},
      {path:'profile',component:ProfileComponent},
      {path:'library',component:LibraryComponent},
      {path:'downloads',component:DownloadsComponent},
      {path:'notifications',component:NotificationComponent},
      {path:'dairy',component:DairyComponent},
      {path:'galimages',component:GalimagesComponent},
      {path:'results',component:ResultComponent},
      
  ]

}
    


];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
